const BUILT_IN: Record<string, string> = {
  squat: 'Squat',
  bench: 'Bench press',
  row: 'Barbell row',
  ohp: 'Overhead press',
  deadlift: 'Deadlift',
  curl: 'Dumbbell curls',
  pushup: 'Push-ups',
};

/** Extra names snapshotted from hosted-plan prescriptions or the catalogue (registered at runtime). */
const extra: Record<string, string> = {};
export function registerExerciseNames(names: Record<string, string | undefined>): void {
  for (const [k, v] of Object.entries(names)) if (v && !BUILT_IN[k]) extra[k] = v;
}

const titleCase = (id: string) => id.replace(/-/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

/** Display name for any exercise id: built-in, then hosted-plan/catalogue names, then a readable fallback. */
export const LIFT_NAME: Record<string, string> = new Proxy(BUILT_IN, {
  get: (t, k) => (typeof k === 'string' ? (t[k] ?? extra[k] ?? titleCase(k)) : undefined),
});
